/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_similarItems = ReadonlyArray<{
    readonly serviceId: string | null;
    readonly categoryPath: string | null;
    readonly browseUrl: string | null;
    readonly categoryCode: string | null;
    readonly title: string | null;
    readonly ecommerceTrackingParams: unknown | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_item">;
    readonly " $refType": "PdpRespSimilarItemsGrid_similarItems";
}>;
export type PdpRespSimilarItemsGrid_similarItems$data = PdpRespSimilarItemsGrid_similarItems;
export type PdpRespSimilarItemsGrid_similarItems$key = ReadonlyArray<{
    readonly " $data"?: PdpRespSimilarItemsGrid_similarItems$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_similarItems">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpRespSimilarItemsGrid_similarItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ecommerceTrackingParams",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '3e38d2fe78be70542eea55c98de6aeb8';
export default node;
